import React from "react";
import {Text, Image, Stack, SimpleGrid} from "@chakra-ui/core";

import Heading from "~/ui/display/Heading";
import Content from "~/ui/structure/Content";
import {useTranslation} from "~/i18n/hooks";

const FEATURES = (t) => [
  {
    id: "excellence",
    image: "/assets/excellence.svg",
    title: t("aboutUs.ourCulture.values.one.title"),
    description: t("aboutUs.ourCulture.values.one.description"),
  },
  {
    id: "culture",
    image: "/assets/culture.svg",
    title: t("aboutUs.ourCulture.values.two.title"),
    description: t("aboutUs.ourCulture.values.two.description"),
  },
  {
    id: "messages",
    image: "/assets/messages.svg",
    title: t("aboutUs.ourCulture.values.three.title"),
    description: t("aboutUs.ourCulture.values.three.description"),
  },
  {
    id: "passion",
    image: "/assets/passion.svg",
    title: t("aboutUs.ourCulture.values.four.title"),
    description: t("aboutUs.ourCulture.values.four.description"),
  },
];

const OurCulture: React.FC = () => {
  const t = useTranslation();

  return (
    <Content paddingX={6} paddingBottom={24}>
      <Stack spacing={{base: 10, md: 12}}>
        <Heading as="h2" fontSize="4xl" maxWidth={480}>
          {t("aboutUs.ourCulture.title")}
        </Heading>
        <SimpleGrid columns={{base: 1, md: 4}} gridGap={12}>
          {FEATURES(t).map((feature) => (
            <Stack key={feature.id} spacing={3}>
              <Image height={20} src={feature.image} width={20} />
              <Text fontSize="lg" fontWeight="bold">
                {feature.title}
              </Text>
              <Text>{feature.description}</Text>
            </Stack>
          ))}
        </SimpleGrid>
      </Stack>
    </Content>
  );
};

export default OurCulture;
